import NewsModule from './containers/newsModule'

export {default as NewsModuleLayout} from './components/newsModuleLayout'

export default NewsModule
